"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = require("axios");

var Api =
/*#__PURE__*/
function () {
  function Api(config) {
    _classCallCheck(this, Api);

    this.METHOD_GET = "GET";
    this.METHOD_POST = "POST";
    this.applyConfig(config);
  }

  _createClass(Api, [{
    key: "applyConfig",
    value: function applyConfig(config) {
      this.config = this.mergeDefaults(config);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "mergeDefaults",
    value: function mergeDefaults(config) {
      var protocol = config.protocol || "http";
      var port = config.port || (protocol === "https" ? 443 : 80);
      return {
        host: config.host || "127.0.0.1",
        protocol: protocol,
        port: port,
        timeout: config.timeout || 20000,
        logging: config.logging || false,
        logger: config.logger || console.log
      };
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(endpoint, config) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.request().get(endpoint, config);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (!(_context.t0.response && _context.t0.response.status)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", _context.t0.response);

              case 10:
                throw _context.t0;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(endpoint, body, config) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.request().post(endpoint, body, config);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

                if (!(_context2.t0.response && _context2.t0.response.status)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", _context2.t0.response);

              case 10:
                throw _context2.t0;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      function post(_x3, _x4, _x5) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
    /**
     * Get an AxiosInstance with the base configuration setup to fire off
     * a request to the network.
     */

  }, {
    key: "request",
    value: function request() {
      var _this = this;

      var instance = axios_1.default.create({
        baseURL: "".concat(this.config.protocol, "://").concat(this.config.host, ":").concat(this.config.port),
        timeout: this.config.timeout
      });

      if (this.config.logging) {
        instance.interceptors.request.use(function (request) {
          _this.config.logger("Requesting: ".concat(request.baseURL, "/").concat(request.url));

          return request;
        });
        instance.interceptors.response.use(function (response) {
          _this.config.logger("Response:   ".concat(response.config.url, " - ").concat(response.status));

          return response;
        });
      }

      return instance;
    }
  }]);

  return Api;
}();

exports.default = Api;